import { Component } from '@angular/core';
import { NavbarComponent } from "@shared/components/layout/navbar/navbar.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    NavbarComponent
  ]
})
export class AppComponent {
}
